import * as Types from '../types-api.generated';

import { MomentOverviewFragment, MomentFragment, UserLightFragment, WorldOverviewFragment, WorldOverviewOnExhibition, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, TokenFragment, NftIdentifiersFragment, AuctionFragment, SaleFragment, SplitFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiCuratedStoresVariables = Types.Exact<{
  creatorPublicKey: Types.Scalars['String'];
  chainId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiCuratedStores = { curatedStores: { moments: Array<{ id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } }>, worlds: Array<{ chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }> } };



export const ApiCuratedStoresDocument = /*#__PURE__*/ `
    query CuratedStores($creatorPublicKey: String!, $chainId: Int) {
  curatedStores(creatorPublicKey: $creatorPublicKey, chainId: $chainId) {
    moments {
      ...MomentOverviewFragment
    }
    worlds: exhibitions {
      ...WorldOverviewOnExhibition
    }
  }
}
    ${MomentOverviewFragment}
${MomentFragment}
${UserLightFragment}
${WorldOverviewFragment}
${WorldOverviewOnExhibition}`;

export const useCuratedStores = <
      TData = ApiCuratedStores,
      TError = ClientError
    >(
      variables: ApiCuratedStoresVariables,
      options?: Omit<UseQueryOptions<ApiCuratedStores, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiCuratedStores, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiCuratedStores, TError, TData>(
      {
    queryKey: ['CuratedStores', variables],
    queryFn: apiFetcher<ApiCuratedStores, ApiCuratedStoresVariables>(ApiCuratedStoresDocument, variables),
    ...options
  }
    )};

useCuratedStores.getKey = (variables: ApiCuratedStoresVariables) => ['CuratedStores', variables];

export const useInfiniteCuratedStores = <
      TData = InfiniteData<ApiCuratedStores>,
      TError = ClientError
    >(
      variables: ApiCuratedStoresVariables,
      options: Omit<UseInfiniteQueryOptions<ApiCuratedStores, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiCuratedStores, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiCuratedStores, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CuratedStores.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiCuratedStores, ApiCuratedStoresVariables>(ApiCuratedStoresDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCuratedStores.getKey = (variables: ApiCuratedStoresVariables) => ['CuratedStores.infinite', variables];


useCuratedStores.fetcher = (variables: ApiCuratedStoresVariables, options?: RequestInit['headers']) => apiFetcher<ApiCuratedStores, ApiCuratedStoresVariables>(ApiCuratedStoresDocument, variables, options);
